import React from 'react';

export default function InfoSection({
  form,
  setForm,
  editHeader,
  setEditHeader,
  project,
  isLocked,
  onRequestEdit,
  readOnly = false,
}) {
  const allowEdit = editHeader && !isLocked && !readOnly;
  return (
    <div className={`doc-info if-card info-wrapper ${editHeader ? 'editing' : ''}`}>
      <div className="doc-info-grid">
        <div className="info-block">
          <label>Project Site</label>
          {!allowEdit ? (
            <p>{form.projectSite || '—'}</p>
          ) : (
            <textarea
              className="if-textarea info-anim"
              value={form.projectSite}
              onChange={(e) => setForm((f) => ({ ...f, projectSite: e.target.value }))}
            />
          )}
        </div>

        <div className="info-block">
          <label>Billing Address</label>
          {!allowEdit ? (
            <p>{form.billingAddress || '—'}</p>
          ) : (
            <textarea
              className="if-textarea info-anim"
              value={form.billingAddress}
              onChange={(e) => setForm((f) => ({ ...f, billingAddress: e.target.value }))}
            />
          )}
        </div>

        <div className="info-block">
          <label>Customer Name</label>
          {!allowEdit ? (
            <p>{form.client.name}</p>
          ) : (
            <input
              className="if-input info-anim"
              value={form.client.name}
              onChange={(e) =>
                setForm((f) => ({
                  ...f,
                  client: { ...f.client, name: e.target.value },
                }))
              }
            />
          )}
        </div>

        <div className="info-block">
          <label>Customer Contact</label>
          {!allowEdit ? (
            <p>
              {form.client.email}
              <br />
              {project?.phone || '—'}
            </p>
          ) : (
            <>
              <input
                className="if-input info-anim"
                type="email"
                value={form.client.email}
                onChange={(e) =>
                  setForm((f) => ({
                    ...f,
                    client: { ...f.client, email: e.target.value },
                  }))
                }
              />
              <input
                className="if-input info-anim"
                style={{ marginTop: 8 }}
                defaultValue={project?.phone || ''}
              />
            </>
          )}
        </div>

        <div className="info-edit">
          {!allowEdit ? (
            !readOnly && (
              <button
                className="edit-btn"
                onClick={() => (isLocked ? onRequestEdit?.() : setEditHeader(true))}
              >
                ✎
              </button>
            )
          ) : (
            <div className="edit-pair fade-buttons">
              <button className="if-btn-secondary" onClick={() => setEditHeader(false)}>
                Cancel
              </button>

              <button className="if-btn-primary" onClick={() => setEditHeader(false)}>
                Save
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
